<template>
  <div class="search-skeleton">
    <div class="skeleton-container">
      <div v-for="(item, index) in NUM_OF_SKELETON" :key="index" class="skeleton-item--search">
        <div class="skeleton-shine subject" />
        <div class="skeleton-shine content" />
        <div class="skeleton-shine content" />
        <div class="skeleton-shine content" />
      </div>
    </div>
  </div>
</template>

<script>
const NUM_OF_SKELETON = document.documentElement.clientWidth >= 768 ? 4 : 2
export default {
  name: 'SearchSkeleton',
  components: {},
  directives: {},
  props: {},
  data() {
    return {
      NUM_OF_SKELETON
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

</style>
